// Global error handler to prevent page refreshes and capture all errors

class GlobalErrorHandler {
  constructor() {
    this.setupGlobalHandlers();
    this.trackPageLoads();
  }

  setupGlobalHandlers() {
    // Form submission interception disabled for production
    // document.addEventListener('submit', ...) - REMOVED

    // Handle unhandled promise rejections
    window.addEventListener('unhandledrejection', (event) => {
      console.error('Unhandled Promise Rejection:', event.reason);
      
      // Prevent the default behavior (which might cause page refresh)
      event.preventDefault();
      
      // Log detailed error information
      this.logError('UNHANDLED_PROMISE_REJECTION', event.reason);
      
      // Show user-friendly error message
      this.showErrorToUser(event.reason);
    });

    // Handle uncaught errors
    window.addEventListener('error', (event) => {
      console.error('Uncaught Error:', event.error);
      
      // Log detailed error information
      this.logError('UNCAUGHT_ERROR', event.error);
      
      // Prevent default behavior
      event.preventDefault();
      
      return true; // Prevent default browser error handling
    });

    // Handle React errors (additional safety net)
    window.addEventListener('rejectionhandled', (event) => {
      console.log('Rejection Handled:', event.reason);
    });
  }

  logError(type, error) {
    // Log to console with minimal information
    console.error(`${type}:`, error?.message || error);

    // In a real app, you might want to send this to an error reporting service
    // could construct errorInfo object here if needed for reporting
  }

  showErrorToUser(error) {
    // Import toast dynamically to avoid circular dependencies
    import('react-hot-toast').then(({ default: toast }) => {
      const message = this.getErrorMessage(error);
      toast.error(message, {
        duration: 6000,
        style: {
          maxWidth: '500px',
        },
      });
    }).catch(console.error);
  }

  getErrorMessage(error) {
    if (typeof error === 'string') {
      return error;
    }

    if (error?.response?.data?.message) {
      return error.response.data.message;
    }

    if (error?.message) {
      return error.message;
    }

    return 'An unexpected error occurred. Please check the console for details.';
  }

  trackPageLoads() {
    // Minimal page tracking for production
    const loadTime = Date.now();
    sessionStorage.setItem('lastLoadTime', loadTime.toString());
    
    // Track beforeunload for cleanup
    window.addEventListener('beforeunload', (event) => {
      // Minimal logging for production
    });
  }

  // Method to manually handle errors
  handleError(error, context = 'MANUAL') {
    this.logError(context, error);
    this.showErrorToUser(error);
  }
}

// Create global instance
const globalErrorHandler = new GlobalErrorHandler();

export default globalErrorHandler;